import { createFileRoute } from '@tanstack/react-router';

import { AdminIntegrationDetailView } from 'src/sections/admin/integration-tasks/admin-integration-detail-view';

export const Route = createFileRoute(
  '/admin-skidog/$orgId/clients/$clientId/integrations/$integrationId',
)({
  component: AdminIntegrationDetailPage,
});

function AdminIntegrationDetailPage() {
  const { orgId, clientId, integrationId } = Route.useParams();
  return (
    <AdminIntegrationDetailView
      organizationId={orgId}
      clientId={clientId}
      integrationId={integrationId}
    />
  );
}
